import PropTypes from 'prop-types';
import clsx from 'clsx';

import Image from '../../../components/Image';
import LoadingOverlay from '../../../components/LoadingOverlay';
import Markup from '../../../components/Markup';
import MediaPlayer from '../../../components/MediaPlayer';
import SlantedButton from '../../../components/SlantedButton';
import Typography from '../../../components/Typography';
import useHomeFullBleed from './hooks/useHomeFullBleed';
import useStyles from './homeFullBleed.styles';

const HomeFullBleed = ({ content }) => {
  const styles = useStyles();
  const { title, href, imgSrc, video, body, disclaimer } = content || {};
  const { ref, inView, initialPlayerState, playerSources } =
    useHomeFullBleed(video);

  return (
    <>
      {imgSrc && !video && (
        <Image className={clsx('full-bleed', styles.image)} src={imgSrc} />
      )}
      {video && (
        <div className="full-bleed">
          <div className={styles.videoWrapper}>
            <a
              ref={ref}
              className={styles.videoInner}
              href={href}
              target="_blank"
              rel="noreferrer"
            >
              <LoadingOverlay className={styles.loading} size={100} />
              {playerSources && inView && (
                <MediaPlayer
                  initialState={initialPlayerState}
                  loop
                  sources={playerSources}
                  withOverlay={false}
                />
              )}
            </a>
          </div>
        </div>
      )}
      <div className={styles.body}>
        <Typography component="div" variant="subtitle" withShadow>
          <Markup content={body} />
        </Typography>
      </div>
      <div className={styles.buttonWrapper}>
        <SlantedButton className={styles.button} component="a" href={href}>
          {title}
        </SlantedButton>
      </div>
      <div className={styles.disclaimer}>
        <Typography variant="bodySmall">{disclaimer}</Typography>
      </div>
    </>
  );
};

HomeFullBleed.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string,
    href: PropTypes.string,
    imgSrc: PropTypes.string,
    body: PropTypes.string,
  }).isRequired,
};

export default HomeFullBleed;
